import translations from "../../translations"
import * as I18n from "../../services/i18n"
import ServiceCompositionSection from "./service_composition_section.coffee"
import CalculateValueFromServiceWithComposition from "./calculate_value_from_service_with_composition.coffee"
import ManageableService from "./manageable_service.coffee"
import QuickRecordField from "./quick_record_field.coffee"
import OptionalReprovalFieldsField from "./optional_reproval_fields_field.coffee"
import MethodImageUploadHandler from './method_images_upload_handler'
import MethodDocumentUploadHandler from './method_documents_upload_handler'
import BuildActionButtons from '../servicos/build_action_buttons.js'
import ServicesCreation from './services_creation.coffee'
import Error from '../../utils/error.coffee'

$(document).on('turbolinks:load', function() {
  ServiceCompositionSection.handler_events()
  CalculateValueFromServiceWithComposition.handler_events()
  ManageableService.handler_events()
  QuickRecordField.handler_events()
  OptionalReprovalFieldsField.handler_events()

  // Reaplica a visibilidade dos campos condicionais (peso/flag de checklist)
  // quando um novo item/método é inserido dinamicamente via Cocoon.
  $('#items-list').on('cocoon:after-insert', function() {
    QuickRecordField.sync()
  })

  new MethodImageUploadHandler().call()
  new MethodDocumentUploadHandler().call()
  new BuildActionButtons().handler_events()
  new ServicesCreation().handler_events()


  $('.js-remove-method-image').on('confirmed', (e)=> {
    const target = $(e.currentTarget)
    const imageId = target.data('id')
    $(`#js-method-image-id-${imageId}`).remove()
    $(`#js-method-image-preview-${imageId}`).remove()
    $(`#js-method-image-gallery-preview-${imageId}`).remove()
  })

  // Remoção de anexo JÁ VINCULADO. Espelha a remoção de imagem: tira o hidden
  // `document_ids` e as linhas do DOM, então o save do serviço deixa de mandar
  // o id e o vínculo cai. Delegado em `document` porque o método pode ter sido
  // inserido dinamicamente (Cocoon) depois do turbolinks:load.
  $(document).on('confirmed', '.js-remove-method-document', (e) => {
    const target = $(e.currentTarget)
    const documentId = target.data('id')
    $(`#js-method-document-id-${documentId}`).remove()
    $(`#js-method-document-preview-${documentId}`).remove()
    $(`#js-method-document-modal-row-${documentId}`).remove()
    $(`#document-hidden-${documentId}`).remove()
  })

  // Renomear mexe SÓ em `display_name` — o guid do documento é a identidade que
  // o app offline usa para saber se já baixou o arquivo, e nunca é regenerado.
  $(document).on('click', '.js-rename-method-document', (e) => {
    const target = $(e.currentTarget)
    const documentId = target.data('id')
    const currentName = target.data('name')

    const newName = window.prompt(
      I18n.t(translations(), 'servicos.show.method_documents.rename_prompt'),
      currentName
    )

    if (newName == null || newName.trim() === '' || newName === currentName) return

    $.ajax({
      type: 'PATCH',
      url: `/method_documents/${documentId}/rename`,
      data: { display_name: newName },
      success: (response) => {
        target.data('name', response.display_name)
        $(`.js-method-document-name-${documentId}`).text(response.filename)
      },
      error: () => {
        new Error.show_alert_flash_msg(I18n.t(translations(), 'servicos.show.method_documents.rename_error'))
      }
    })
  })

  $(document).on('blur', '.servico-item-observacao', (e) => {
    const item = $(e.currentTarget)
    $(`.btn-cancel-observacao-${item.data('order')}`).attr('data-confirm', I18n.t(translations(), 'servicos.form.cancel_confirm'))
  })

  $(document).on('confirmed', `.btn-cancel-observacao`, (e) => {
    const item = $(e.currentTarget)
    $(`.btn-cancel-observacao-${item.data('order')}`).removeAttr('data-confirm')
    item.parents(`.lightbox-observacao-${item.data('order')}`).modal('hide')
  })

  $(document).on('click', '.btn-cancel-observacao', (e) => {
    const item = $(e.currentTarget)
    let observacao = item.parents(`.lightbox-observacao-${item.data('order')}`).find('.servico-item-observacao-hide')
    let new_observacao = item.parents(`.lightbox-observacao-${item.data('order')}`).find(`.servico-item-observacao-${item.data('order')}`)
    new_observacao.val(observacao.val())
    
    if (!item.data('confirm')) {
      item.parents(`.lightbox-observacao-${item.data('order')}`).modal('hide')
    }
  })

  const updateObservacaoCounter = ($textarea) => {
    const order = $textarea.data('order')
    const length = ($textarea.val() || '').length
    const exceeded = length > 1000
    $(`.servico-item-observacao-counter-${order}`)
      .text(`${length} / 1000`)
      .css('color', exceeded ? '#d9534f' : '#888')
      .css('font-weight', exceeded ? 'bold' : 'normal')
  }

  $(document).on('input keyup change paste', '.servico-item-observacao', (e) => {
    updateObservacaoCounter($(e.currentTarget))
  })

  $(document).on('shown.bs.modal', '.lightbox-observacao', (e) => {
    $(e.currentTarget).find('.servico-item-observacao').each((_, el) => {
      $(el).removeAttr('maxlength')
      updateObservacaoCounter($(el))
    })
  })

  $('.servico-item-observacao').each((_, el) => {
    $(el).removeAttr('maxlength')
    updateObservacaoCounter($(el))
  })

  $(document).on('click', '.btn-confirm-observacao', (e) => {
    const item = $(e.currentTarget)
    const observacao = item.parents(`.lightbox-observacao-${item.data('order')}`).find('.servico-item-observacao-hide')
    const new_observacao = item.parents(`.lightbox-observacao-${item.data('order')}`).find(`.servico-item-observacao-${item.data('order')}`)
    observacao.val(new_observacao.val())
    $(`.clickable-${item.data('order')}`).text(I18n.t(translations(), 'servicos.form.editar_observacao'))
  })

  $(document).on('click', '.collapse-icon', function() {
    $('.parent-colapse').collapse('hide')
    const collapseTarget = $(this).data('target')
    $(collapseTarget).collapse('show')
  })

  $(document).on('keypress', '#items-list', (event) => {
    const enterKeyCode = 13
    return (event.charCode || event.keyCode) !== enterKeyCode
  })

  // Cocoon já gerencia a remoção corretamente:
  // - Registros NOVOS (dynamic): remove do DOM
  // - Registros EXISTENTES (existing): esconde e seta _destroy="1"
  // NÃO remover elementos escondidos, senão o _destroy não é enviado no form

  $(document).on('click', '#checkbox-disable-mobile-status-change', function() {
    let checked = $(this).prop('checked')
    console.log('changed', checked)
    $('#disable-mobile-status-change-alert').toggleClass('hide', !checked)
  });

  // Validação do campo Percentual Inicial de Avanço
  $(document).on('input blur', '#servico_servico_initial_progress_percentage', function() {
    let value = parseFloat($(this).val())
    let field = $(this)
    
    // Remove mensagem de erro anterior
    field.removeClass('is-invalid')
    field.next('.invalid-feedback').remove()
    
    if (isNaN(value) || value < 0 || value > 100) {
      field.addClass('is-invalid')
      field.after('<div class="invalid-feedback">O percentual deve estar entre 0 e 100</div>')
      
      // Corrige o valor automaticamente
      if (value < 0) {
        field.val(0)
      } else if (value > 100) {
        field.val(100)
      }
    }
  });

  // Bloqueia finalizar serviço sem ao menos 1 item de inspeção e 1 metodo por item.
  // Itens/métodos removidos pelo cocoon (existentes) ficam com _destroy="1"; novos são retirados do DOM.
  const filledAndKept = (root, removeSelector, descSelector) =>
    $(root).find(removeSelector + ' input[name$="[_destroy]"]').first().val() !== '1' &&
    ($(root).find(descSelector).first().val() || '').trim() !== ''

  const activeItems = () =>
    $('#items-list > li.list-item').toArray().filter((item) =>
      filledAndKept(item, '.remove-item', '.item-description'))

  const itemHasMethod = (item) =>
    $(item).find('li.list-metodo').toArray().some((method) =>
      filledAndKept(method, '.remove-subitem', '[name$="[dsc_item_metodo]"]'))

  const inspectionError = () => {
    const items = activeItems()
    if (items.length === 0) return I18n.t(translations(), 'servicos.form.validation.no_items')
    if (items.some((item) => !itemHasMethod(item))) return I18n.t(translations(), 'servicos.form.validation.item_without_method')
    return null
  }

  const guardInspectionSubmit = (e) => {
    const message = inspectionError()
    if (!message) return

    e.preventDefault()
    e.stopImmediatePropagation()
    $('.nav-step-02').trigger('click')
    Error.show_alert_flash_msg(message)
  }

  $('#servico_form').on('submit', guardInspectionSubmit)
  $('#servico_form .steps-submit').on('click', guardInspectionSubmit)
})
